import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { SoldProduct } from '../types/entities';

interface SaleDeleteConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  sale: SoldProduct | null;
}

const SaleDeleteConfirmationDialog: React.FC<SaleDeleteConfirmationDialogProps> = ({
  open,
  onClose,
  onConfirm,
  sale,
}) => {
  const { t } = useTranslation();
  if (!sale) return null;

  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('pl-PL', {
      style: 'currency',
      currency: 'PLN',
    }).format(amount);
  };

  const formatDate = (date: Date) => {
    return new Intl.DateTimeFormat('pl-PL', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).format(new Date(date));
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">{t('sales.deleteSale')}</Typography>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{ color: (theme) => theme.palette.grey[500] }}
          >
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          {t('dialogs.confirmDeleteSale')}
        </Typography>
        <Box sx={{ mt: 2 }}>
          <Typography variant="body2" color="text.secondary">
            <strong>{t('sales.product')}:</strong> {sale.product.name}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            <strong>{t('sales.quantity')}:</strong> {sale.amount}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            <strong>{t('sales.price')}:</strong> {formatCurrency(sale.price)}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            <strong>{t('sales.client')}:</strong> {sale.client.name}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            <strong>{t('common.date')}:</strong> {formatDate(sale.createdAt)}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'flex-end', px: 3, pb: 2 }}>
        <Button onClick={onConfirm} color="error" variant="contained">
          {t('common.delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SaleDeleteConfirmationDialog;

